import {create} from 'zustand';
import {PlaceActivityDetailDto} from '../../generated/models/PlaceActivityDetailDto';

// Using your generated type as the internal DTO
export type PlaceSummaryInternalDto = PlaceActivityDetailDto;

export interface PlaceListStore {
  placeList: PlaceSummaryInternalDto[] | null;
  selectedPlaceId: string | null;
  setPlaceList: (placeList: PlaceSummaryInternalDto[]) => void;
  setSelectedPlaceId: (placeId: string) => void;
  clearPlaceListStore: () => void;
}

export interface PlaceDetailsStore {
  placeDetails: PlaceActivityDetailDto | null;
  selectedPlaceDetailsId: string | null;
  setPlaceDetails: (placeDetails: PlaceActivityDetailDto) => void;
  setSelectedPlaceDetailsId: (placeDetailsId: string) => void;
  clearPlaceDetails: () => void;
}

export interface PlaceDtoStore {
  placeDto: PlaceActivityDetailDto | null;
  setPlaceDto: (placeDetails: PlaceActivityDetailDto) => void;
  clearPlaceDto: () => void;
}

// 1. Store for the list view (All Places)
export const usePlaceListStore = create<PlaceListStore>()(set => ({
  placeList: null,
  selectedPlaceId: null,
  setPlaceList(placeList) {
    set({placeList});
  },
  setSelectedPlaceId(selectedPlaceId) {
    set({selectedPlaceId});
  },
  clearPlaceListStore() {
    set({placeList: null, selectedPlaceId: null});
  },
}));

// 2. Store for individual place details/viewing
export const usePlaceDetailsStore = create<PlaceDetailsStore>()(set => ({
  placeDetails: null,
  selectedPlaceDetailsId: null,
  setSelectedPlaceDetailsId(selectedPlaceDetailsId) {
    set({selectedPlaceDetailsId});
  },
  setPlaceDetails(placeDetails) {
    set({placeDetails});
  },
  clearPlaceDetails() {
    set({placeDetails: null, selectedPlaceDetailsId: null});
  },
}));

// 3. Store for creating/editing a place (Data Transfer Object)
export const usePlaceDtoStore = create<PlaceDtoStore>()(set => ({
  placeDto: null,
  setPlaceDto(placeDto) {
    set({placeDto});
  },
  clearPlaceDto() {
    set({placeDto: null});
  },
}));
